/**
 * Identificadores.
 *
 * A chave de um evento **nasce no aparelho, junto com a ação** — nunca no
 * envio. É a decisão que faz reenviar ser inofensivo: se a chave nascesse no
 * envio, uma repetição por rede ruim geraria chave nova e o servidor trataria
 * como apontamento diferente. Etapa concluída duas vezes, tempo dobrado, e
 * ninguém descobre até o relatório do mês não fechar.
 *
 * (Mesma regra do `fila.ts` do Nexo em Campo, e pela mesma razão.)
 */

/** UUID v4. Usa `crypto.randomUUID` quando existe; senão, `getRandomValues`. */
export function novoId(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  if (c && typeof c.getRandomValues === 'function') {
    const b = c.getRandomValues(new Uint8Array(16));
    b[6] = ((b[6] ?? 0) & 0x0f) | 0x40;
    b[8] = ((b[8] ?? 0) & 0x3f) | 0x80;
    const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
  }
  throw new Error('Sem gerador de aleatórios: não dá para criar identificador de evento.');
}
